export default __webpack_public_path__ + "static/media/avatarB8.cc9fed04.png";